import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from "mobx-react";
import { InfoTile } from '@myplay/ui';

import "./HeaderTiles.scss";

const HeaderTiles = ({ MetricsStore }) => {
  return (
    <div className="header-tiles" data-testid="header-tiles">
      {Object.values(MetricsStore).map(tile =>
        tile ?
          <div key={tile.title} className="header-tiles__tile-container">
            <InfoTile  {...tile} />
          </div> : null
      )}
    </div>
  );
};

HeaderTiles.propTypes = {
  MetricsStore: PropTypes.object  
};

HeaderTiles.defaultProps = {
  MetricsStore: {}
};

export default inject("MetricsStore")(observer(HeaderTiles));